import React from "react";

const AccrodianComponent = ({ data, type }) => {
  console.log(type);

  if (!data) {
    return <div className="p-4 text-red-500">No data provided</div>;
  }

  // Render different content based on accordion type
  const renderContent = () => {
    switch (type) {
      case "personal":
        return (
          <div className="bg-info-50 p-4 rounded">
            <h3 className="font-bold text-info-800 mb-3">
              Personal Information
            </h3>
            <div className="grid grid-cols-3 gap-3 text-sm">
              <div>
                <strong>Full Name:</strong> {data.fullName?.firstName}{" "}
                {data.fullName?.middleName} {data.fullName?.lastName}
              </div>
              <div>
                <strong>Age:</strong> {data.age}
              </div>
              <div>
                <strong>Gender:</strong> {data.gender}
              </div>
              <div>
                <strong>Hobbies:</strong> {data.hobby?.join(", ")}
              </div>
            </div>
          </div>
        );

      case "work":
        return (
          <div className="bg-green-50 p-4 rounded">
            <h3 className="font-bold text-success-800 mb-3">Work Details</h3>
            <div className="grid grid-cols-3 gap-3 text-sm">
              <div>
                <strong>Company:</strong> {data.company}
              </div>
              <div>
                <strong>Department:</strong> {data.department}
              </div>
              <div>
                <strong>Salary:</strong> ${data.salery}
              </div>
              <div>
                <strong>Joined Date:</strong> {data.joindedDate}
              </div>
              <div>
                <strong>Status:</strong> {data.status}
              </div>
            </div>
          </div>
        );

      case "contact":
        return (
          <div className="bg-leave-50 p-4 rounded">
            <h3 className="font-bold text-leave-800 mb-3">
              Contact Information
            </h3>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <strong>Email:</strong> {data.email}
              </div>
              <div>
                <strong>Phone:</strong> {data.phone}
              </div>
              <div>
                <strong>Address:</strong> {data.address}
              </div>
              <div>
                <strong>Country:</strong> {data.countries}
              </div>
            </div>
          </div>
        );

      default:
        return (
          <div className="p-4">
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </div>
        );
    }
  };

  return <div className="w-full">{renderContent()}</div>;
};

export default AccrodianComponent;
